import { useCallback, useState } from 'react';
import { z } from 'zod';

const STORAGE_KEY = 'ncc.sidebar';
const stored = z.object({ collapsed: z.boolean() });

function read(): boolean {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = stored.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data.collapsed : false;
  } catch {
    // Corrupt JSON or storage blocked: fall back to expanded.
    return false;
  }
}

/** Sidebar collapsed state, remembered in localStorage (zod-parsed; bad values mean expanded). */
export function useCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState(read);
  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ collapsed: next }));
      } catch {
        // Storage blocked: the choice lasts for this visit only.
      }
      return next;
    });
  }, []);
  return [collapsed, toggle];
}
